import { API_ROUTES } from 'src/constants/routes';
import { httpClient } from 'src/libs';

const update = (data) => {
  // Build payload dynamically to include deliver_after only when provided
  const payload: any = {
    content: data.content,
    raw_content: data.raw_content ?? data.content,
    channel_id: data.channelId,
  };

  if (data.deliver_after) {
    payload.deliver_after = data.deliver_after;
  }

  return httpClient.put(`${API_ROUTES.message}/${data.messageId}`, payload);
};

const destroy = (data) => {
  return httpClient.delete(`${API_ROUTES.message}/${data.messageId}`, { params: { channel_id: data.channelId } });
};

const deliver = (data) => {
  return httpClient.post(`${API_ROUTES.message}/deliver_message`, { message_id: data.messageId, channel_id: data.channelId });
};

const force_deliver_now = (data) => {
  return httpClient.post(`${process.env.REACT_APP_BASE_URL}/comms-api/messages/${data.messageId}/deliver_now`, { channel_id: data.channelId });
};

const reschedule_delivery = (data) => {
  return httpClient.put(`${API_ROUTES.message}/${data.messageId}/reschedule_delivery`, {
    channel_id: data.channelId,
    deliver_after: data.deliver_after,
  });
};

const post_message = (data) => {
  return httpClient.post(`${API_ROUTES.message}/post_message`, data);
}

const get = (data) => {
  return httpClient.get(`${API_ROUTES.message}/${data.messageId}`, { params: { channel_id: data.channelId } });
}

const MessagesService = {
  update,
  destroy,
  deliver,
  force_deliver_now,
  reschedule_delivery,
  post_message,
  get
};

export default MessagesService;
